var map = {
	"./dummy.png": 956,
	"./kuhn-rikon-schneidbrett.jpg": 8116,
	"./le_creuset_br_ter_oval-6.jpg": 456,
	"./logo.svg": 1937,
	"./startseite-stimmungsbild.jpg": 3244,
	"./villeryo-boch-teekanne.jpg": 1586,
	"./zwilling-fleischmesser.jpg": 552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;